/**
 * Constants tracker.
 * 
 * @author Gilang Romadhanu Tartila
 */
"use strict";

export const COOKIE_NAME_SESSION = 'SOCIOLLA_SESSION_ID';
export const COOKIE_NAME_UTM = 'SOCIOLLA_UTM_DATA';
export const COOKIE_NAME_AVAILABLE = ['utm_source', 'utm_medium', 'utm_campaign', 'traffic_id', 'aff_sid', 'affiliate_code'];